<template>
  <footer class="footer">
    <!-- 页脚主体 -->
    <div class="site_footage">
      <!-- 站点地图区域 -->
      <div class="sitemap_box">
        <!-- <div class="footer-logo">
          <img src="https://aka.doubaocdn.com/s/CYf31wXbKo" alt="CIGARERA" />
        </div> -->
        <div class="sitemap">
          <div class="sitemap-col">
            <div class="sitemap-heading">{{ $t('footer.about_us') }}</div>
            <div class="sitemap-links">
              <a href="javascript:;" @click.prevent="openPage('aboutus', $t('footer.about_timecigar'))">{{ $t('footer.about_timecigar') }}</a>
              <a href="javascript:;" @click.prevent="openPage('tiaokuan', $t('footer.terms'))">{{ $t('footer.terms') }}</a>
              <a href="javascript:;" @click.prevent="openPage('yinsi', $t('footer.privacy'))">{{ $t('footer.privacy') }}</a>
              <a href="javascript:;" @click.prevent="openPage('refundzc', $t('footer.return_policy'))">{{ $t('footer.return_policy') }}</a>
            </div>
          </div>
          <!-- <div class="sitemap-col">
            <div class="sitemap-heading">{{ $t('footer.member_benefits') }}</div>
            <div class="sitemap-links">
              <a href="javascript:;">{{ $t('footer.time_club') }}</a>
            </div>
          </div>
          <div class="sitemap-col">
            <div class="sitemap-heading">{{ $t('footer.customer_service') }}</div>
            <div class="sitemap-links">
              <a href="javascript:;">{{ $t('footer.payment_pricing') }}</a>
              <a href="javascript:;">{{ $t('footer.order_shipping') }}</a>
              <a href="javascript:;">{{ $t('footer.exchange_policy') }}</a>
              <a href="javascript:;">{{ $t('footer.cigar_care') }}</a>
                <a
                  href="javascript:;"
                  @click.prevent="openQualityGuarantee"
                >{{ $t('footer.quality_guarantee') }}</a>
            </div>
          </div> -->
        </div>
      </div>
      <!-- 联系方式区域 -->
      <div class="footer_etc">
        <div class="footer_contact">
          <div class="contact-heading">{{ $t('footer.contact_us') }}</div>
          <div class="contact-info">
            <!-- <div class="nofakes-logo">
              <img src="@/assets/static/index/nofakes_logo2026.webp" alt="No Fakes" />
            </div> -->
            <div class="contact-details">
              <div v-if="contactInfo.email" class="mail"><a :href="'mailto:' + contactInfo.email">{{ contactInfo.email }}</a></div>
              <div v-if="contactInfo.phone" class="phone"><a :href="'tel:' + contactInfo.phone">{{ contactInfo.phone }}</a></div>
              <div v-if="contactInfo.address" class="address">{{ contactInfo.address }}</div>
              <div v-if="contactInfo.worktime" class="cs-hour"><span>{{ contactInfo.worktime }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 版权信息 -->
    <!-- <div class="cr_box">
      <div class="flex">
        <div class="cr-text">{{ $t('footer.copyright') }}</div>
        <div class="cr-notice">{{ $t('footer.warning') }}</div>
      </div>
      <div class="setting">
        <div class="lang_div">
          <div class="lang_tab" @click="toggleLanguage">{{ currentLangLabel }}</div>
        </div>
      </div>
    </div> -->
    <!-- 移动端底部导航 -->
    <!-- <div class="footer_mobile">
      <div class="mobile-nav-item" @click="$router.push('/about')">
        <i class="fa fa-user"></i>
        <span>{{ $t('footer.mobile_nav.my') }}</span>
      </div>
      <div class="mobile-nav-item" @click="$router.push('/cart')">
        <i class="fa fa-shopping-bag"></i>
        <span>{{ $t('footer.mobile_nav.cart') }}</span>
      </div>
    </div> -->

    <!-- 彈窗：品質保證 -->
    <QualityGuaranteeModal
      :visible="qualityGuaranteeVisible"
      @close="qualityGuaranteeVisible = false"
    />

    <!-- 彈窗：通用單頁 -->
    <PageModal
      :visible="pageModalVisible"
      :page-key="pageModalKey"
      :title="pageModalTitle"
      @close="pageModalVisible = false"
    />
  </footer>
</template>

<script>
import QualityGuaranteeModal from './common/QualityGuaranteeModal.vue'
import PageModal from './common/PageModal.vue'

export default {
  name: 'AppFooter',
  components: { QualityGuaranteeModal, PageModal },
  data() {
    return {
      qualityGuaranteeVisible: false,
      pageModalVisible: false,
      pageModalKey: '',
      pageModalTitle: '',
      contactInfo: {
        email: '',
        phone: '',
        address: '',
        worktime: ''
      }
    }
  },
  created() {
    this.fetchContact()
  },
  computed: {
    currentLangLabel() {
      return this.$store.state.language === 'zh' ? 'EN' : this.$t('footer.lang_zh_tw')
    }
  },
  methods: {
    async fetchContact() {
      try {
        const res = await this.$api.home.getContact()
        if (res.code === 1 && res.data) {
          const d = res.data
          const isEn = this.$store.state.language === 'en'
          this.contactInfo = {
            email: d.contact_email || '',
            phone: d.contact_phone || '',
            address: isEn ? (d.contact_addr_en || d.contact_addr || '') : (d.contact_addr || ''),
            worktime: d.worktime || ''
          }
        }
      } catch (e) {
        console.error('联系方式获取失败', e)
      }
    },
    openQualityGuarantee() {
      this.qualityGuaranteeVisible = true
    },
    openPage(key, title) {
      this.pageModalKey = key
      this.pageModalTitle = title
      this.pageModalVisible = true
    },
    toggleLanguage() {
      const newLang = this.$store.state.language === 'zh' ? 'en' : 'zh'
      this.$store.commit('SET_LANGUAGE', newLang);
      //刷新当前页面
      window.location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #303436;
  color: #ffffff;
  font-size: 13px;
}

/* 页脚主体 */
.site_footage {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 50px 50px 80px;
}

/* 站点地图区域 */
.sitemap_box {
  flex: 0 0 55%;
}

.footer-logo {
  margin-bottom: 25px;

  img {
    max-width: 120px;
    filter: brightness(0) invert(1);
  }
}

.sitemap {
  display: flex;
  gap: 40px;
}

.sitemap-col {
  .sitemap-heading {
    margin-bottom: 15px;
    font-size: 14px;
    color: #ffffff;
    font-weight: 400;
  }

  .sitemap-links {
    a {
      display: block;
      font-size: 13px;
      color: #999999;
      padding: 3px 0;
      transition: color 0.3s;

      &:hover {
        color: #ffffff;
      }
    }
  }
}

/* 联系方式区域 */
.footer_etc {
  flex: 0 0 45%;
  text-align: right;
}

.footer_contact {
  padding-top: 0;
  flex-direction: column;
  gap: 15px;
  display: flex;

  .contact-heading {
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    padding: 10px 0 8px;
  }
  .contact-info {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
  }
}

.nofakes-logo {
  img {
    max-width: 100px;
  }
}

.contact-details {
  .mail {
    margin-bottom: 8px;

    a {
      font-size: 13px;
      color: #999999;
      transition: color 0.3s;

      &:hover {
        color: #ffffff;
      }
    }
  }

  .cs-hour {
    font-size: 13px;
    color: #999999;
    line-height: 1.8;

    span:first-child {
      margin-right: 8px;
    }
  }
}

/* 版权信息 */
.cr_box {
  background-color: #333333;
  color: #ffffff;
  font-size: 11px;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #3e3e3e;
}

.cr_box > .flex {
  display: flex;
  padding: 5px 17px;
  margin-right: 20px;
}

.cr-text {
  color: #ffffff;
  font-size: 11px;
  padding: 5px 17px;
}

.cr-notice {
  color: #ffffff;
  font-size: 11px;
  padding: 5px 17px;
}

.setting {
  display: flex;
  text-align: right;
  align-items: center;
  padding: 5px 17px;

  > div {
    margin-left: 20px;
    cursor: pointer;
  }
}

.lang_div {
  .lang_tab {
    color: #ffffff;
    font-size: 11px;
    cursor: pointer;
    padding: 2px 8px;
    border: 1px solid #666;
    border-radius: 3px;
    transition: all 0.3s;

    &:hover {
      border-color: #fff;
    }
  }
}

/* 移动端底部导航 */
.footer_mobile {
  display: none;
  position: fixed;
  bottom: 24px;
  left: 0;
  right: 0;
  background: #303436;
  border-top: 1px solid #444;
  padding: 8px 0;
  z-index: 100;
  justify-content: space-around;

  .mobile-nav-item {
    text-align: center;
    cursor: pointer;
    color: #999999;
    transition: color 0.3s;

    &:hover {
      color: #ffffff;
    }

    i {
      font-size: 18px;
      display: block;
      margin-bottom: 2px;
    }

    span {
      font-size: 11px;
      font-weight: 400;
    }
  }
}

/* 响应式 */
@media (max-width: 820px) {
  .site_footage {
    // flex-direction: column;
    padding: 40px 30px 80px;
    gap: 30px;
  }

  .sitemap_box,
  .footer_etc {
    flex: none;
  }

  .sitemap {
    gap: 30px;
  }
}

@media (max-width: 500px) {
  .site_footage {
    padding: 30px 20px 80px;
  }

  .footer_mobile {
    display: flex;
  }

  .sitemap {
    flex-direction: column;
    gap: 16px;
  }

  .sitemap-col .sitemap-links a {
    font-size: 13px;
    padding: 6px 0;
  }
  .setting {
    display: none;
  }
  .cr_box {
    flex-direction: column;
    gap: 2px;
    text-align: center;
    padding: 5px 17px;
    position: relative;
  }
}
</style>
